export default __webpack_public_path__ + "static/media/H4010.2.34c57611.mp3";